export default {
  name: "PinSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M24.5 4.56C22.52 2.36 19.26 1 16 1S9.48 2.36 7.5 4.56C5.17 7.14 4.51 9.9 5.27 13.82c1.03 5.3 9.58 16.33 9.94 16.8a1 1 0 0 0 1.58-.01c.36-.47 8.91-11.5 9.94-16.8.76-3.91.1-6.67-2.23-9.25zM16 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8z",
  },
}
